import React, { Component } from 'react';

import logo from '../images/Steve_GD3C2732_RG.jpg';
import mvplogo from '../images/mvp.png';

export default class About extends React.Component {
    render() {
      return (
              <div className="App-Body">
              <header className="App-header">
              </header>
              <div className="VBWhite">
              <div><img src={logo} className="App-logo" alt="logo" /></div>
                <div><p>Our MD is Steve Spencer and is our principle consultant.</p>
                <p> Steve has many years experience working in Consultancy, Product Development, Project Delivery and Internal Services.
                </p>
                </div>
              </div>
              <div className="VBInverse">
                <div>
                <p>He specialises in the folowing technologies and tools:
                </p>
                  <ul> 
                    <li>Microsoft's cloud computing platform, Azure</li>
                    <li>C#</li>              
                    <li>SQL</li>
                    <li>Dynamics CRM</li>
                    <li>Enterprise Messaging (RabbitMQ, Azure Service Bus)</li>
                    <li>Integration and Data manipulation (Azure Logic Apps, Pentaho)</li>
                    <li>Azure DevOps</li>
                  </ul>
                  <p>Steve writes <a href="http://blogs.recneps.org" className="VBInverse">blogs</a> and creates <a href="http://blogs.recneps.net/post/My-Video-Library" className="VBInverse">videos</a> mainly on Azure based topics. Steve regularly presents at user grops and developer conferences</p>
                  <img src={mvplogo} className="App-logo-sm" alt="mvplogo" />
                  <p>Steve has been a Microsoft MVP in Microsoft Azure since 2010.
                </p>
                <p>"Microsoft Most Valuable Professionals, or MVPs, are technology experts who passionately share their knowledge with the community. They are always on the "bleeding edge" and have an unstoppable urge to get their hands on new, exciting technologies. They have very deep knowledge of Microsoft products and services, while also being able to bring together diverse platforms, products and solutions, to solve real world problems. MVPs make up a global community of over 4,000 technical experts and community leaders across 90 countries/regions and are driven by their passion, community spirit, and quest for knowledge. Above all and in addition to their amazing technical abilities, MVPs are always willing to help others - that's what sets them apart." <a href="https://mvp.microsoft.com/en-US/Overview" className="VBInverse">more</a>
                  </p></div>
                </div>
              </div>);          
    }
  }